export default __webpack_public_path__ + "static/media/tarjeta_personal.588f1216.png";